export const CONNECTIONS_REQUEST_AMOUNT = 50;
